import { Route } from "vue-router";
import { toBool } from "./convert";

let lIsDebug = false;

export function isLocalhost() {
  return window.location && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
}

export function isDevSite() {
  const firstCharacters = "paytef-dev-";
  return window.location && window.location.hostname.startsWith(firstCharacters);
}

export function isDebug() {
  return lIsDebug;
}

export function setDebug(val: boolean) {
  lIsDebug = val;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(...params: any) {
  if (lIsDebug) {
    // eslint-disable-next-line no-console
    console.log(...params);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logError(...params: any) {
  // eslint-disable-next-line no-console
  console.error(...params);
}

export function checkRouteDebug(route: Route) {
  if (isLocalhost()) {
    setDebug(true);
  } else if (route.query && toBool(route.query.debug)) {
    setDebug(true);
  }
}

export function promiseEnd<T>(p: Promise<T>) {
  p.catch((err) => logError("Unhandled promise error", err));
}
